const React = require("react");
const T = require("prop-types");
const TextField = require("material-ui/TextField").default;
const RaisedButton = require("material-ui/RaisedButton").default;
const FlatButton = require("material-ui/FlatButton").default;
const NavLink = require("react-router-dom").NavLink;
const Paper = require("material-ui/Paper").default;
const IsEmail = require("utils/is-email");
const History = require("wiring/history");

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "4rem 0"
};

internals.buttonLabelStyle = {
    textTransform: "inherit",
    color: "#E07056"
};

module.exports = class Login extends React.Component {
    static propTypes = {
        login: T.func.isRequired,
        location: T.object.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            email: "",
            confirmEmailHasBlurred: false,
            password: "",
            confirmPasswordHasBlurred: false
        };

        this.loginUser = this._loginUser.bind(this);
        this.confirmEmailBlurred = this._confirmEmailBlurred.bind(this);
        this.confirmPasswordBlurred = this._confirmPasswordBlurred.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    _confirmEmailBlurred() {
        this.setState({ confirmEmailHasBlurred: true });
    }

    _confirmPasswordBlurred() {
        this.setState({ confirmPasswordHasBlurred: true });
    }

    handleEmailChange = event => {
        this.setState({
            email: event.target.value
        });
    };

    handlePasswordChange = event => {
        this.setState({
            password: event.target.value
        });
    };

    _loginUser(ev) {
        ev.preventDefault();
        this.props.login(
            this.state.email,
            this.state.password,
            this.props.location.state
                ? this.props.location.state.redirect
                : null
        );
    }

    render() {
        const {
            email,
            confirmEmailHasBlurred,
            password,
            confirmPasswordHasBlurred
        } = this.state;

        const emailError =
            confirmEmailHasBlurred && (email === "" || !IsEmail(email));

        const passwordEmpty =
            confirmPasswordHasBlurred && password.length === 0;

        const isButtonDisabled = !(IsEmail(email) && !passwordEmpty);

        return (
            <Paper style={internals.paperStyle}>
                <form onSubmit={this.loginUser}>
                    <h2>Login</h2>
                    <div className="form-group">
                        <TextField
                            floatingLabelText="Email"
                            value={email}
                            onChange={this.handleEmailChange}
                            onBlur={this.confirmEmailBlurred}
                            errorText={emailError && "Please enter your email"}
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            floatingLabelText="Password"
                            value={password}
                            onChange={this.handlePasswordChange}
                            type="password"
                            onBlur={this.confirmPasswordBlurred}
                            errorText={
                                passwordEmpty && "Please enter your password "
                            }
                        />
                    </div>
                    <RaisedButton
                        primary
                        label="Login"
                        onClick={this.loginUser}
                        labelStyle={{
                            textTransform: "inherit"
                        }}
                        type="submit"
                        disabled={isButtonDisabled}
                    />
                    <NavLink to="/designer-instructions" />
                </form>
                <div className="form-subnote">
                    {"Don't have an account? "}
                    <FlatButton
                        label="Sign up"
                        labelStyle={internals.buttonLabelStyle}
                        onClick={() =>
                            History.push("/create-account", {
                                redirect: "/buycredits?checkout"
                            })
                        }
                    />
                </div>
                <div className="form-subnote form-subnote--secondary">
                    <NavLink to="/forgot-password">Forgot password?</NavLink>
                </div>
            </Paper>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/login/components/Login.js